import React from "react";
import "./AboutPage.css";

import about1 from "../../Assets/About/about-1.jpg";
import about2 from "../../Assets/About/about-2.jpg";

import Services from "../../Components/Home/Services/Services";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Autoplay } from "swiper/modules";

import brand1 from "../../Assets/Brands/brand1.png";
import brand2 from "../../Assets/Brands/brand2.png";
import brand3 from "../../Assets/Brands/brand3.png";
import brand4 from "../../Assets/Brands/brand4.png";
import brand5 from "../../Assets/Brands/brand5.png";
import brand6 from "../../Assets/Brands/brand6.png";
import brand7 from "../../Assets/Brands/brand7.png";
import SEO from '../SEO/seo';
const AboutPage = () => {
  return (
    <>
      <SEO
        title="About Eadaad - Your Trusted Islamic Products Store"
        description="Eadaad offers high-quality Islamic products including counter tasbihs, Islamic caps, athar perfumes, and Hajj essentials. Shop authentic Islamic essentials with us."
        keywords="Islamic products online, counter tasbih, buy Islamic caps, best athar, Hajj essentials, Islamic store in Pakistan, premium tasbih, Sunnah perfumes"
        url="https://www.eadaad.com/about"
      
      />
      <div className="aboutSection">
        <h2>Your Trusted Islamic Products Store</h2>
        <img src={about1} alt="Buy high-quality Islamic products - Eadaad" />
        <div className="aboutContent">
          <h3>Our Story</h3>
          <h4>
            At Eadaad, our journey began with a simple yet powerful vision—to provide high-quality Islamic products that enrich the spiritual lives of Muslims around the world. We understand the importance of faith in daily life and the role that well-crafted Islamic essentials play in strengthening that connection.
          </h4>
          <p>
            From counter tasbihs for daily zhikr to Islamic caps, athar (fragrances), and Hajj,Umrah essentials, every product we offer is selected with care, ensuring authenticity, purity, and excellence.

            Our mission is to make it easier for every Muslim to access the best Islamic products, whether for personal use or as a meaningful gift for loved ones. InshaAllah, we aspire to spread the beauty of Islamic traditions and encourage their use in everyday life.

            Eadaad is more than just a store—it is a commitment to quality, faith, and community. We invite you to embark on this journey with us, ensuring that every product you purchase serves as a means of spiritual growth and connection.
          </p>
          <div className="content1">
            <div className="contentBox">
              <h5>Our Mission</h5>
              <p>
              <p>To provide <strong>premium Islamic essentials</strong> that strengthen faith and spirituality.</p>              </p>
            </div>
            <div className="contentBox">
              <h5>Our Vision</h5>
              
              <p>To become the <strong>leading Islamic eCommerce store</strong>, making quality Islamic products accessible worldwide.</p>
              
            </div>
          </div>
          <div className="content2">
            <div className="imgContent">
              <img src={about2} alt="Islamic Product Store" />
            </div>
            <div className="textContent">
              <h5>The Company</h5>
              <p>
                Eadaad is a trusted online store specializing in <strong>authentic Islamic products</strong>. From 
                <strong> premium tasbih beads and Islamic caps</strong> to <strong>Sunnah perfumes</strong> and <strong>Hajj & Umrah essentials</strong>, we ensure quality and 
                reliability in every product. Our mission is to serve the global Muslim community with a seamless shopping experience.
              </p>
            </div>
          </div>
        </div>
      </div>
      <Services />
      <div className="companyPartners">
        <h5>Company Partners</h5>
        <Swiper
          slidesPerView={1}
          loop={true}
          breakpoints={{
            640: {
              slidesPerView: 2,
              spaceBetween: 5,
            },

            768: {
              slidesPerView: 4,
              spaceBetween: 40,
            },

            1024: {
              slidesPerView: 5,
              spaceBetween: 50,
            },
          }}
          spaceBetween={10}
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
          }}
          modules={[Autoplay]}
        >
          <SwiperSlide>
            <div className="aboutBrands">
              <img src={brand1} alt="" />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="aboutBrands">
              <img src={brand2} alt="" />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="aboutBrands">
              <img src={brand3} alt="" />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="aboutBrands">
              <img src={brand4} alt="" />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="aboutBrands">
              <img src={brand5} alt="" />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="aboutBrands">
              <img src={brand6} alt="" />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="aboutBrands">
              <img src={brand7} alt="" />
            </div>
          </SwiperSlide>
        </Swiper>
      </div>
    </>
  );
};

export default AboutPage;
